/** Loads the Google Identity Services script and renders its sign-in button. */

const GSI_SRC = "https://accounts.google.com/gsi/client"

interface GsiId {
  initialize(config: { client_id: string; callback: (response: { credential: string }) => void }): void
  renderButton(parent: HTMLElement, options: Record<string, unknown>): void
}

declare global {
  interface Window {
    google?: { accounts?: { id?: GsiId } }
  }
}

let scriptPromise: Promise<void> | null = null

function loadScript(): Promise<void> {
  if (window.google?.accounts?.id) return Promise.resolve()
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script")
      script.src = GSI_SRC
      script.async = true
      script.onload = () => resolve()
      script.onerror = () => {
        scriptPromise = null
        script.remove()
        reject(new Error("Could not load Google sign-in."))
      }
      document.head.appendChild(script)
    })
  }
  return scriptPromise
}

export async function renderGoogleButton(
  parent: HTMLElement,
  clientId: string,
  onCredential: (credential: string) => void,
): Promise<void> {
  await loadScript()
  const id = window.google?.accounts?.id
  if (!id) throw new Error("Could not load Google sign-in.")
  id.initialize({
    client_id: clientId,
    callback: (response) => onCredential(response.credential),
  })
  id.renderButton(parent, { theme: "outline", size: "large", text: "signin_with", width: 336 })
}
